import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import IconButton from "@mui/material/IconButton";
import { closeSnackbar, SnackbarProvider } from "notistack";
import { type ReactNode } from "react";

import { PublicSvgIcon } from "~/components/public_svg_icon";

interface NotificationsProviderProps {
  children: ReactNode;
}

export function NotificationsProvider({
  children,
}: NotificationsProviderProps) {
  return (
    <SnackbarProvider
      maxSnack={4}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      autoHideDuration={5000}
      preventDuplicate
      iconVariant={{
        success: (
          <PublicSvgIcon
            name="check_circle_outlined"
            sx={{
              paddingRight: 1.5,
            }}
          />
        ),
        error: (
          <PublicSvgIcon
            name="error_outline"
            sx={{
              paddingRight: 1.5,
            }}
          />
        ),
      }}
      action={(snackbarId) => (
        <IconButton
          onClick={() => closeSnackbar(snackbarId)}
          sx={{ color: "inherit" }}
        >
          <CloseOutlinedIcon fontSize="small" />
        </IconButton>
      )}
    >
      {children}
    </SnackbarProvider>
  );
}
